<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M6.85 11.67v-1h2.3v1zM4.27 8.5v-1h7.45v1zM2.33 5.33v-1h11.34v1z"
      />
    </svg>
  </span>
</template>
